export default __webpack_public_path__ + "static/media/workaware-light.6b97208d.png";